<script setup>
import { ref, onMounted } from 'vue';
import { useWaitlistStore } from '../store/useWaitlist';
const props = defineProps({
  item: { type: Object, required: true },
});
const emit = defineEmits(['close']);
const store = useWaitlistStore();
const services = ref([]);
const agendas = ref([]);
const serviceId = ref('');
const agendaId = ref('');
const slots = ref([]);
const loadingOpcoes = ref(true);
const loadingSlots = ref(false);
const agendando = ref(false);
const erro = ref('');
const verSlots = ref(false);
onMounted(async () => {
  const o = await store.opcoes();
  services.value = o.services;
  agendas.value = o.agendas;
  serviceId.value = o.services[0]?.id || '';
  const g = o.agendas.find(a => a.tem_gcal);
  agendaId.value = (g || o.agendas[0])?.id || '';
  loadingOpcoes.value = false;
});
async function verHorarios() {
  loadingSlots.value = true;
  erro.value = '';
  verSlots.value = true;
  try {
    const now = new Date();
    const fim = new Date(now.getTime() + 7 * 864e5);
    const r = await store.slots(serviceId.value, agendaId.value, now.toISOString(), fim.toISOString());
    slots.value = r.slots || [];
  } catch (e) {
    erro.value = 'Falha ao buscar horários';
  } finally {
    loadingSlots.value = false;
  }
}
function fmt(iso) { const d = new Date(iso); return d.toLocaleString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); }
async function escolher(slot) {
  if (agendando.value) return;
  agendando.value = true;
  erro.value = '';
  try {
    const r = await store.criarAgendamento({
      service_id: serviceId.value,
      agenda_id: agendaId.value,
      inicio: slot,
      nome_cliente: props.item.nome,
      telefone: props.item.telefone,
      contato_chatwoot_id: props.item.contact_chatwoot_id,
      conversation_chatwoot_id: props.item.conversation_chatwoot_id,
    });
    if (r && r.ok) {
      await store.marcarAgendado(props.item.id);
      emit('close');
    } else {
      erro.value = 'Não foi possível agendar';
    }
  } catch (e) {
    erro.value = 'Erro ao agendar';
  } finally {
    agendando.value = false;
  }
}
</script>
<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" @click.self="emit('close')">
    <div class="bg-n-background rounded-xl p-5 w-[28rem] shadow-lg">
      <h2 class="font-semibold mb-3">Agendar — {{ item.nome }}</h2>
      <div v-if="loadingOpcoes" class="text-n-slate-11 text-sm mb-3">Carregando opções…</div>
      <template v-else>
        <label class="block text-xs mb-1">Serviço</label>
        <select v-model="serviceId" style="color-scheme: dark" class="w-full mb-2 px-2 py-1 rounded border border-n-weak bg-transparent text-sm">
          <option v-for="s in services" :key="s.id" :value="s.id" style="background-color:#1f2d3d;color:#fff">{{ s.nome }} ({{ s.duracao_min }}min)</option>
        </select>
        <label class="block text-xs mb-1">Agenda</label>
        <select v-model="agendaId" style="color-scheme: dark" class="w-full mb-3 px-2 py-1 rounded border border-n-weak bg-transparent text-sm">
          <option v-for="a in agendas" :key="a.id" :value="a.id" style="background-color:#1f2d3d;color:#fff">{{ a.nome }}{{ a.tem_gcal ? ' 📅' : '' }}</option>
        </select>
        <button class="px-3 py-1 rounded bg-n-brand text-white text-sm mb-3" :disabled="agendando" @click="verHorarios">Ver horários</button>
        <div v-if="verSlots" class="mb-3">
          <div v-if="loadingSlots" class="text-n-slate-11 text-sm">Buscando…</div>
          <div v-else-if="slots.length" class="max-h-64 overflow-auto flex flex-col gap-1">
            <button
              v-for="s in slots"
              :key="s"
              class="px-3 py-1 rounded border border-n-weak text-sm text-left hover:bg-n-alpha-2 disabled:opacity-50"
              :disabled="agendando"
              @click="escolher(s)"
            >{{ fmt(s) }}</button>
          </div>
          <div v-else class="text-n-slate-11 text-sm">Nenhum horário livre nos próximos 7 dias.</div>
        </div>
        <div v-if="agendando" class="text-n-slate-11 text-sm mb-2">Agendando…</div>
        <div v-if="erro" class="text-red-500 text-sm mb-2">{{ erro }}</div>
      </template>
      <div class="flex justify-end">
        <button class="px-3 py-1" :disabled="agendando" @click="emit('close')">Fechar</button>
      </div>
    </div>
  </div>
</template>
